import {useState, useContext} from 'react';
import {AxiosContext} from 'components/utils/AxiosProvider';
import axios from 'axios';

const useDeleteEndpoint = endpoint => {
    const [submissionInProgress, setSubmissionInProgress] = useState(null);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const {client: axiosClient} = useContext(AxiosContext);

    const onFormPosted = result => {
        setSubmissionInProgress(false);
        error && setError(null);
        setResult(result.data);
    };

    const onError = error => {
        setSubmissionInProgress(false);
        result && setResult(null);
        setError(error.response?.data);
    };

    const destroy = (formParams, formData = null, authToken = null) => {
        setSubmissionInProgress(true);
        if (formData && authToken) {
            axios({
                method: 'delete',
                url: endpoint,
                headers: {
                    authorization: authToken,
                    'Content-Type': 'application/json',
                },
                data: formData,
            })
                .then(onFormPosted)
                .catch(onError);
        } else {
            axiosClient
                .delete(endpoint, {params: formParams})
                .then(onFormPosted)
                .catch(onError);
        }
    };

    const reset = () => {
        setSubmissionInProgress(null);
        setResult(null);
        setError(null);
    };

    return {
        destroy,
        submissionInProgress,
        result,
        error,
        reset,
    };
};

const useDeleteProfile = email => {
    return useDeleteEndpoint(`/api/1/admin/user/delete_profile/${email}`);
};

const useAdminDeleteRole = () => {
    return useDeleteEndpoint(`/api/1/admin/user/remove_role`);
};

const useAdminDeleteUser = () => {
    return useDeleteEndpoint(`/api/1/admin/user/delete`);
};

const useAdminDeleteTestUser = () => {
    return useDeleteEndpoint(`/api/1/admin/testusers`);
};

const useAdminDeleteApplication = id => {
    return useDeleteEndpoint(`/api/1/admin/application/${id}`);
}

const useDeleteEndpointActive = endpoint => {
    const [submissionInProgress, setSubmissionInProgress] = useState(null);
    const [result, setResult] = useState(null);
    const [error, setError] = useState(null);
    const axiosClient = useContext(AxiosContext);

    const onFormPosted = result => {
        setSubmissionInProgress(false);
        error && setError(null);
        setResult(result.data);
    };

    const onError = error => {
        setSubmissionInProgress(false);
        result && setResult(null);
        setError(error.response?.data);
    };

    const destroy = url => {
        setSubmissionInProgress(true);
        axiosClient
            .delete(`${endpoint}${url}`)
            .then(onFormPosted)
            .catch(onError);
    };

    const reset = () => {
        setSubmissionInProgress(null);
        setResult(null);
        setError(null);
    };

    return {
        destroy,
        submissionInProgress,
        result,
        error,
        reset,
    };
};

const useDeleteProfileActive = () => {
    return useDeleteEndpointActive(`/api/1/admin/user/delete_profile/`);
};

export default useDeleteEndpoint;
export {
    useDeleteEndpointActive,
    useDeleteProfile,
    useDeleteProfileActive,
    useAdminDeleteRole,
    useAdminDeleteUser,
    useAdminDeleteTestUser,
    useAdminDeleteApplication,
};
